import React, { useState, useRef, useEffect } from "react";
import { Form, Button, Col, Row } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { useUser } from "../../../components/UserContext";
import LoadingContent from "../../../components/LoadingContent";
import { faDiscord } from "@fortawesome/free-brands-svg-icons";
import { countryCodeToFlag } from "../../../utils/Admin";

const UploadRaceDiscord = ({ data }: { data: any }) => {
  const { user } = useUser() as any;
  const token = window.localStorage.getItem("userLogged");
  const [dataForm, setDataForm] = useState({
    name: "",
    code: "",
  });
  const [validated, setValidated] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [discordTitle, setDiscordTitle] = useState(``);

  const [discordEmbed, setDiscordEmbed] = useState(``);
  useEffect(() => {
    setDiscordTitle(
      `${countryCodeToFlag(data.grand_prix.grand_prix.flag.code)} LVF1 ${data.grand_prix.name.toUpperCase()}`,
    );
    setDiscordEmbed(
      [
        "🏆 **Race Results**",
        data.results_link + "\n",
        "",
        "📓 **Standings**",
        `https://ligavirtualf1.es/en/Season/${data.grand_prix.grand_prix.championship.name.replace(/\s+/g, "")}\n`,
        "",
        data.next_gp == null
          ? ""
          : `🔴 **${
              data.grand_prix.grand_prix.championship.type_championship !== 3
                ? "Server Online"
                : "Next Race"
            }**\n${data.next_gp.circuit} · Race · ${data.next_gp.date_converted}`,
      ]
        .filter(Boolean)
        .join("\n"),
    );
  }, [data]);

  const submitForm = (event: any) => {
    if (token == null) return;
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    const formDataFiles = new FormData();
    formDataFiles.append("discord_title", discordTitle);
    formDataFiles.append("discord_embed", discordEmbed);
    formDataFiles.append(
      "type_championship",
      data.grand_prix.grand_prix.championship.type_championship,
    );
    formDataFiles.append("grand_prix_event_id", data.grand_prix_event_id);
    formDataFiles.append("user", user);
    formDataFiles.append("token", JSON.parse(token).token);

    if (!(form !== null && form.checkValidity() === false)) {
      setUploading(true);
      axios
        .post(
          `${
            process.env.NODE_ENV === "development"
              ? "http://localhost:5500"
              : "https://ligavirtualf1.es:5500"
          }/api/admin/publishDiscordRaceResults`,
          formDataFiles,
        )
        .then(() => {
          toast.success("Discord message created successfully");
          setUploading(false);
          setValidated(false);
          setDataForm({ ...dataForm, name: "", code: "" });
        })
        .catch(({ response }) => {
          toast.error("Error: Code duplicated");
          setUploading(false);
          setValidated(false);
          throw new Error(response);
        });
    }
    setValidated(true);
  };

  if (data == null) return <LoadingContent />;
  return (
    <Form
      noValidate
      validated={validated}
      onSubmit={submitForm}
      className="discord-form"
    >
      <Row className="mb-3">
        <Form.Group className="form-group col-md-12">
          <h4>
            {" "}
            <FontAwesomeIcon icon={faDiscord} /> Discord [including @Role + GP
            Image]
          </h4>
          <Form.Label>Title (*)</Form.Label>
          <Form.Control
            required
            name="discord_title"
            type="text"
            value={discordTitle}
            onChange={(e) => setDiscordTitle(e.target.value)}
          />
        </Form.Group>
        <Form.Group className="form-group" as={Col} md="12">
          <Form.Label>Embed (*)</Form.Label>
          <Form.Control
            required
            as="textarea"
            name="discord_embed"
            rows={9}
            value={discordEmbed}
            onChange={(e) => setDiscordEmbed(e.target.value)}
          />
          <Form.Control.Feedback type="invalid">
            Field required
          </Form.Control.Feedback>
        </Form.Group>
      </Row>
      <div className="text-center">
        {uploading ? (
          <FontAwesomeIcon icon={faSpinner} className="spinner-button" />
        ) : (
          <Button type="submit" variant="secondary">
            Send Discord Message
          </Button>
        )}
      </div>
    </Form>
  );
};

export default UploadRaceDiscord;
